import type { ProductFormConfig } from 'modules/supplier/products';
import { PressConfigForm } from './PressConfigForm';

export * from './types';
export * from './columns';
export * from './PressConfigForm';
export * from './PressFormatForm';

export const pressProductConfig: ProductFormConfig = {
  Component: PressConfigForm,
  initialValues: {
    position: null,
    placement: null,
    section: null,
    format: null,
  },
  // Null fields are explicit empty details; off removes the configuration row.
  help: 'off for a generic product sold by free geometry',
};
